import cookie from '../cookie'

export default class Profile {
  constructor(api) {
    this.api = api
  }

  getDevices = async opts => {
    const res = await this.api.get('/GetMyDevices', {
      ...opts,
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      params: { upgraded: false, checkReplacementLimit: true },
      mock: 'myDevices.json'
    })
    cookie.setToken(res.auth_token)
    return res
  }

  getMyCoupons = async opts => {
    const res = await this.api.get('/profile/coupons', {
      ...opts,
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      params: { historicaldata: true },
      mock: 'myCoupons.json'
    })
    cookie.setToken(res.auth_token)
    return res
  }

  claimCoupon = async () => {
    const res = await this.api.post('/ClaimDri', {
      headers: {
        ...cookie.authorizationTokenHeader()
      }
    })
    cookie.setToken(res.auth_token)
    return res
  }

  registerDevice = async data => {
    const res = await this.api.post('/DeviceRegistration', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      withCredentials: true,
      data,
      mock: 'deviceRegistration.json'
    })
    cookie.setToken(res.auth_token)
    return res
  }

  getOrders = async opts => {
    const res = await this.api.get('/GetOrders', {
      ...opts,
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: 'myOrders.json'
    })
    cookie.setToken(res.auth_token)
    return res
  }

  cancelOrder = async orderId => {
    const res = await this.api.post('/order/cancel', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      data: {
        OrderId: orderId
      },
      mock: 'cancelOrder.json'
    })

    cookie.setToken(res.auth_token)
    return res
  }

  getProfileInfo = async opts => {
    const res = await this.api.get('/GetProfileInfo', {
      ...opts,
      headers: {
        ...cookie.authorizationTokenHeader(opts ? opts.req : undefined)
      },
      mock: 'getProfileInfo.json'
    })
    return res
  }

  getProfile = async opts => {
    const res = await this.api.get('/GetProfile', {
      ...opts,
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: 'getProfile.json'
    })
    cookie.setToken(res.auth_token)
    return res
  }

  updateProfile = async (opts, token) => {
    const res = await this.api.put('/UpdateProfile', {
      withCredentials: true,
      ...opts,
      headers: token
        ? {
            Authorization: `Bearer ${token}`
          }
        : {
            ...cookie.authorizationTokenHeader()
          },
      mock: 'updateProfile.json'
    })
    cookie.setToken(res.auth_token)
    return res
  }

  getTobaccoDelivery = async (opts = {}) => {
    const res = await this.api.get('/account/tva', {
      headers: {
        ...cookie.authorizationTokenHeader(opts.req)
      },
      mock: 'getTobaccoDelivery.json'
    })
    cookie.setToken(res.auth_token)
    return res
  }

  updateTobaccoDelivery = async data => {
    const res = await this.api.post('/account/tva', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      data,
      mock: 'updateTobaccoDelivery.json'
    })
    cookie.setToken(res.auth_token)
    return res
  }
}
